import DefaultValidation from "@/services/validations/DefaultValidation";
import { isNull } from "@/functions/Util";

export default class FormaPagamentoValidation extends DefaultValidation{

    validate(model, refs) {
        let validated = true;

        Object.entries(model).forEach(([key, value]) => {
        if(value!=null && typeof value == "string") model[key] = value.trim();
        });

        if (isNull(model.descricao)) {
        refs.nomeInput.focusedOut = true;
        validated = false;
        }

        if (isNull(model.idformapagtoerp)) {
            refs.idErpInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}